<template>
  <div class="troop-item h-outer-border around-4 bz0 bw2" :class="{empty: !troop.creatureName}">
    <div class="shortcut flex justify-end h-outer-border around-4 bz0 bw2">
      <div class="btn h-title nowrap" data-title="将所有格子覆盖为当前部队" v-click-sound-button @click="handleOverlapToTroop">覆盖</div>
      <div class="btn h-title nowrap" data-title="将空格填充为当前部队" v-click-sound-button @click="handleFillToTroop">填充</div>
      <div class="btn h-title nowrap" data-title="删除当前部队" v-click-sound-button @click="clear">删除</div>
    </div>

    <HSelect style="margin-bottom: 3px;"
             ref="townSelect"
             placeholder="选择城镇"
             :options="towns"
             :value="troop.faction"
             optionsMaxHeight="310px"
             @optionsShow="$refs.creatureSelect.hideOptions()"
             @input="handleSelectFaction">
    </HSelect>
    <HSelect ref="creatureSelect"
             placeholder="选择生物"
             :value="troop.creatureName"
             :options="creaturesOptions"
             @input="handleSelectUnit">
    </HSelect>

    <img :src="`${$rHost}/img/creature/avatar/${troop.creatureName || 'CPRLBLK'}.jpg`"
         alt="" @click="handleSelectItem">

    <div class="amount-info flex h-outer-border around-4 bz0 bw2">
      <div class="input-value flex">
        <div class="mini-btn minus"
             v-click-sound-button
             :disabled="!troop.creatureName || troop.amount <= 1"
             @click="handleMinusAmount">-
        </div>
        <div class="value">
          <input type="text" maxlength="4" :value="troop.amount || 0" @blur="handleLimitAmount($event)">
        </div>
        <div class="mini-btn"
             v-click-sound-button
             :disabled="!troop.creatureName || troop.amount >= 9999"
             @click="handleAddAmount">+
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import HSelect from '@/components/h-select'
  import troopList from '@/components/h-mode-free/data/troopList'

  const MAX_AMOUNT = 9999

  export default {
    name: 'troop-item',

    data () {
      return {
        MAX_AMOUNT,
        towns: troopList.map((d) => {
          return {
            text: d.factionCn,
            value: d.faction,
            icon: `${this.$rHost}/img/common/race/${d.faction}.jpg`
          }
        }),
      }
    },

    props: {
      dataIndex: {
        type: Number,
        default: null
      }
    },

    computed: {
      ...mapState('freeConfig', [
        'troops'
      ]),

      troop () {
        return this.troops[this.dataIndex]
      },

      creaturesOptions () {
        return (troopList.find((d) => d.faction === this.troop.faction)?.creatures || []).map((d) => {
          return {
            text: d.text,
            value: d.value,
            amount: 1,
            icon: `${this.$rHost}/img/creature/avatar/${d.value}.jpg`
          }
        })
      }
    },

    watch: {},

    mounted () {
    },

    methods: {
      ...mapMutations('freeConfig', [
        'updateTroop',
        'overlapToTroop',
        'fillToTroop',
      ]),
      ...mapActions('freeConfig', [
        'selectTroopItem',
      ]),

      clear () {
        this.updateTroop({
          index: this.dataIndex,
          troop: {},
        })
        // this.$refs.townSelect.clear()
        // this.$refs.creatureSelect.clear()
      },

      handleSelectFaction (value) {
        if (value !== this.troop.faction) {
          const updateData = {
            index: this.dataIndex,
            troop: {
              faction: value,
              creatureName: '',
              amount: this.troop.amount
            }
          }
          this.updateTroop(updateData)
        }
      },

      handleSelectUnit (name) {
        const updateData = {
          index: this.dataIndex,
          troop: {
            faction: this.troop.faction,
            creatureName: name,
            amount: this.troop.amount || 1
          }
        }
        this.updateTroop(updateData)
      },

      handleSelectItem () {
        this.selectTroopItem(this.dataIndex)
      },

      handleLimitAmount (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        const amount = Math.max(1, Math.min(+v, MAX_AMOUNT))
        const updateData = {
          index: this.dataIndex,
          troop: {
            faction: this.troop.faction,
            creatureName: this.troop.creatureName,
            amount: amount
          }
        }
        this.updateTroop(updateData)

        this.$forceUpdate()
      },

      handleMinusAmount () {
        if (!this.troop.creatureName) {
          return
        }

        const amount = Math.max(1, this.troop.amount - 1)
        const updateData = {
          index: this.dataIndex,
          troop: {
            faction: this.troop.faction,
            creatureName: this.troop.creatureName,
            amount: amount
          },
        }
        this.updateTroop(updateData)
      },

      handleAddAmount () {
        if (!this.troop.creatureName) {
          return
        }
        const amount = Math.min(MAX_AMOUNT, this.troop.amount + 1)
        const updateData = {
          index: this.dataIndex,
          troop: {
            faction: this.troop.faction,
            creatureName: this.troop.creatureName,
            amount: amount
          },
        }
        this.updateTroop(updateData)
      },

      handleFillToTroop () {
        this.fillToTroop(this.dataIndex)
      },
      handleOverlapToTroop () {
        this.overlapToTroop(this.dataIndex)
      },

      handleClearTroop () {

      },

    },

    components: {
      HSelect,
    }
  }
</script>

<style lang="stylus" scoped>
  .shortcut
    position relative
    padding 4px 3px
    margin-bottom 3px
    .btn
      position relative
      z-index 1
      margin 0 2px
      line-height 14px
      font-size 12px
      cursor pointer
      color rgba(255, 255, 255, 0.6)
      text-shadow 1px 1px 1px #000
      &:hover
        color rgba(255, 255, 255, 0.8)
      &:active
        color rgba(255, 255, 255, 0.5)

  .troop-item
    position relative
    flex-shrink 0
    width 111px
    padding 3px
    > img
      position relative
      box-sizing border-box
      margin-top 5px
      width 100%
      border 2px solid #000
      vertical-align top
    &.active > img
      border 2px solid $colorGold
    &:not(:last-child)
      margin-right 2px
    &:hover
      .mini-btn
        opacity 1
    &.selected
      > img
        border-color $colorOrange

  .amount-info
    position relative
    flex-direction column
    margin-top 5px
    padding 2px 3px
    .input-value
      align-items center
      .value
        position relative
        flex-grow 1
        text-align right
        whiteText1()
        input
          position relative
          width 100%
          height 24px
          padding 0 2px
          text-align center
          line-height 24px
          font-size 12px
          letter-spacing 1px

  .mini-btn
    opacity 0
    flex-shrink 0
    goldText1()
    z-index 1
    width 22px
    height 22px
    font-size 18px
    border 1px solid #78624a
    border-radius 2px
    line-height 20px
    text-align center
    background-color #392519
    user-select none
    &.minus
      line-height 18px
    &:hover
      cursor pointer
      border-color lighten(#78624a, 10%)
      color darken($colorGold, 30%)

  .mini-btn[disabled]
    filter grayscale(1)
    cursor not-allowed
</style>
